import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { YouthPhotoService } from '../@core/youth-photo.service';
import { AlertService } from '@app/@core/services/alert.service';
import { AppService } from '@app/@core/services/app.service';
import { SharedService } from '@app/@core/services/shared.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { LocalService } from '@app/@core/services/local.service';
declare const $: any;
const deletePhotoSelector = '#deletephoto';

@Component({
  standalone: false,
  selector: 'app-view-youth-photo',
  templateUrl: './view-youth-photo.component.html',
  styleUrls: ['./view-youth-photo.component.scss']
})
export class ViewYouthPhotoComponent implements OnInit {

  showPrimary = false
  youthPhotoList: any[] = [];
  imageUrl: any;
  youthPhotoId: any;
  sourceKey: string;
  sourceValue: string;
  youthId: string;
  scarPhotoList: any[] = [];
  youthPhotoListDefault: any[] = [];
  scarPhotoListDefault: any[] = [];
  primaryFlag: boolean;
  pageId: string;
  permissionStore: PermissionStore;
  pageAccess: any;

  constructor(private router: Router,
    private youthPhotoService: YouthPhotoService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private localStorage: LocalService,
    private appService: AppService) {
    this.sourceKey = this.route.parent.parent.snapshot.paramMap.get('sourceKey');
    this.sourceValue = this.route.parent.parent.snapshot.paramMap.get('sourceValue');
    if (this.sourceKey && this.sourceKey.includes('youth_id')) {
      this.youthId = this.sourceValue;
    }
  }

  ngOnInit(): void {
    this.route.parent?.params.subscribe(params => {
      this.pageId = params['pageId'];
      console.log('Page ID:', this.pageId);
    });
    // Fetch permissions here
    this.localStorage.setItem('gridAction', 'add');
    this.youthPhotoService.getActivePage(this.pageId, true, 'add').subscribe(res => {
      if (res && 'data' in res) {
        const pageResponse = res as { data: { pagePermission: any; assetPermissions: any } };
        this.pageAccess = pageResponse.data.pagePermission;
        const assetAccess = pageResponse.data.assetPermissions;
        this.permissionStore.state['pageAccess'] = this.pageAccess;
        this.permissionStore.state['assetAccess'] = assetAccess;
      } else {
        console.error('Unexpected response format:', res);
      }
    });
    this.getYouthPhotoList();
  }

  showPrimayIcon(item) {
    if(item?.primary_flag) {
      return;
    }
    const flag = !item.primary_flag
    const obj = {
      youth_id: Number(item?.youth_id),
      youth_photo_id: Number(item?.youth_photo_id),
      photo_date: item?.photo_date,
      type_code: item?.type_code,
      primary_flag: flag ? 'Y' : 'N',
      description: item.description,
      url_pic: item.file_name,
      entered_by_worker_id: Number(item.entered_by_worker_id),
      entered_date: item.entered_date
    }
    this.youthPhotoService.updateYouthPhoto(obj).subscribe((res: any) => {
      console.log(res, 'updateddd');
      this.appService.setValue('youth_pic', item.url_pic);
      this.youthPhotoList = [];
      this.scarPhotoList = [];
      this.getYouthPhotoList();
    })
  }

  closePopup(item) {
    this.imageUrl = item.url_pic;
    this.youthPhotoId = item.youth_photo_id;
    this.primaryFlag = item.primary_flag;
    $(deletePhotoSelector).modal('show');
  }

  showPreviewPhoto(item) {
    this.imageUrl = item.url_pic;
    $("#photoPreview").modal('show');
  }

  addPhoto() {
    this.localStorage.setItem('setTabAction', 'add');
    this.sharedService.sendMessage();
    this.localStorage.setItem('gridAction', 'add');
    this.router.navigate(['../upload-image'], { relativeTo: this.route });
  }

  getYouthPhotoList() {
    this.youthPhotoService.getYouthPhoto(this.youthId).subscribe((res: any) => {
      console.log(res, 'youthphotot list');
      if (res && res.data) {
        const youthPhotoData = res.data;
        youthPhotoData.forEach(ele => {
          if (ele.primary_flag === 'Y') {
            ele['primary_flag'] = true
            this.appService.setValue('youth_pic', ele.url_pic);
          } else if (ele.primary_flag === 'N') {
            ele['primary_flag'] = false
          }
        });
        youthPhotoData.forEach(typ => {
          if (typ.type_code === 'YTH') {
            this.youthPhotoList.push(typ);
          } else {
            this.scarPhotoList.push(typ);
          }
        });
        const hasPrimaryFlag = this.youthPhotoList?.some(item => item.primary_flag === true);
        if (!hasPrimaryFlag && this.youthPhotoList.length) {
          this.showPrimayIcon(this.youthPhotoList[0]);
        } else if (!this.youthPhotoList.length) {
          this.appService.setValue('youth_pic', '');
        }
        this.youthPhotoListDefault = this.youthPhotoList;
        this.scarPhotoListDefault = this.scarPhotoList;
        console.log(this.youthPhotoList, this.scarPhotoList, "photot list");
      }

    })
  }

  deletePhoto() {
    this.youthPhotoService.deleteYouthPhoto(this.youthPhotoId).subscribe((res: any) => {
      if (res?.data?.warn) {
        this.alertService.warn(res.data.warn);
        this.youthPhotoId = '';
        $(deletePhotoSelector).modal('hide');
        this.getYouthPhotoList();
        this.youthPhotoList = [];
        this.scarPhotoList = [];
      }
      else if (res?.data?.message){
        this.alertService.success(res.data.message);
        this.youthPhotoId = '';
        $(deletePhotoSelector).modal('hide');
        this.getYouthPhotoList();
        this.youthPhotoList = [];
        this.scarPhotoList = [];
      }
    },
  (error) => {
    this.alertService.error(error.error.message);
    $(deletePhotoSelector).modal('hide');
  })
  }

  editPhoto(item) {
    this.router.navigate([`../upload-image/${item.youth_photo_id}`], { relativeTo: this.route })
  }

  getWorkerName(item) {
    if (item.first_name || item.last_name) {
      return `${item.last_name} ${item.first_name}`;
    } else {
      return ''; 
    }
  }

}
